import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UserListComponent } from './user-list/user-list.component';
import { UserEditComponent } from './user-edit/user-edit.component';
import { UsersRoutingModule} from "./users-routing.module";

import { SharedModule } from "../shared/shared.module";
import { UserDeleteComponent } from './user-delete/user-delete.component';
import { UserNewComponent } from './user-new/user-new.component';

@NgModule({
  imports: [
    FormsModule
    ,SharedModule
    ,UsersRoutingModule
  ],
  declarations: [UserListComponent, UserEditComponent, UserDeleteComponent
    ,UserNewComponent]
  ,providers: []
  ,exports: []
})
export class UsersModule { }



// WEBPACK FOOTER //
// ./src/app/users/users.module.ts